import { parse } from 'qs';

export const getPageKey = () => {
  if (typeof window === 'undefined') return '';

  const query = parse(location.search.replace('?', ''));
  return query?.pageKey as string;
};
